import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import spanish from 'vuetify/lib/locale/es'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
      locales: { spanish },
      current: 'spanish',
    },
  });
